import { render } from "./MediaExplorer.vue?vue&type=template&id=c2a8f7c6"
import script from "./MediaExplorer.vue?vue&type=script&lang=js"
export * from "./MediaExplorer.vue?vue&type=script&lang=js"

import "./MediaExplorer.vue?vue&type=style&index=0&id=c2a8f7c6&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__